import styled from 'styled-components';
import { Row } from 'antd';

const LZRow = styled(Row)`
  margin-top: ${(props) => (props.margintop ? props.margintop : 0)};
  margin-left: ${(props) => (props.marginleft ? props.marginleft : 0)};
  margin-right: ${(props) => (props.marginright ? props.marginright : 0)};
  margin-bottom: ${(props) => (props.marginbottom ? props.marginbottom : 0)};
`;

export default LZRow;
